/* eslint-disable no-magic-numbers */
import { RequestCacheStrategy } from '@mihanizm56/fetch-api/dist/utils/browser-api-cache/_types';
import { APP_NAMESPACE } from '@/_constants/i18next/app-namespace';
import { appVersion } from '@/_utils/version';

type TStrategy = {
  [key: string]: RequestCacheStrategy;
};

const EXPIRES = {
  hour: 1000 * 60 * 60,
  week: 1000 * 60 * 60 * 24 * 7,
  twoWeeks: 1000 * 60 * 60 * 24 * 14,
  month: 1000 * 60 * 60 * 24 * 30,
};

export const STRATEGY: TStrategy = {
  cacheFirst: 'CacheFirst',
  staleWhileRevalidate: 'StaleWhileRevalidate',
  NetworkFirst: 'NetworkFirst',
};

export const DEFAULT_API_CACHE_PARAMS = {
  storageCacheName: `${APP_NAMESPACE}__${appVersion}__requests-cache`,
  debug: true,
  // process.env.NODE_ENV === 'development' ||
  disabledCache: window?.ENVS?.DISABLED_API_CACHE === 'true',
  expires: EXPIRES.twoWeeks,
};
